var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-row", [
        _c(
          "ul",
          { staticClass: "metric-list" },
          _vm._l(_vm.metrics, function(m) {
            return _c(
              "li",
              {
                key: m.name,
                staticClass: "metric-item",
                on: {
                  click: function($event) {
                    return _vm.onClickMetric(m)
                  }
                }
              },
              [
                _c("div", { staticClass: "metric-icon", class: m.color }, [
                  _c("i", { class: m.icon })
                ]),
                _c("div", { staticClass: "metric-content", class: m.color }, [
                  _c("div", { staticClass: "metric-wrapper" }, [
                    _c("div", { staticClass: "metric-number" }, [
                      _vm._v(" " + _vm._s(_vm.overviewStats[m.name]) + " ")
                    ]),
                    _c("div", { staticClass: "metric-name" }, [
                      _vm._v(" " + _vm._s(_vm.$t(m.label)) + " ")
                    ])
                  ])
                ])
              ]
            )
          }),
          0
        )
      ]),
      _c(
        "el-row",
        [
          _c("el-card", { attrs: { shadow: "hover" } }, [
            _c("h4", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.$t("Daily New Tasks")))
            ]),
            _c("div", {
              staticClass: "echarts-box",
              attrs: { id: "echarts-daily-tasks" }
            })
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }